import * as React from 'react';
import { Input } from 'semantic-ui-react';
import moment from 'moment';
import MediaQuery from 'react-responsive';

// Components
import AsyncDatePicker from 'components/AsyncDatePicker';

interface Props {
    input: {
        value: any,
        name: string,
        onBlur: Function,
        onChange: Function
    };
    label?: string;
    placeholder?: string;
    meta: {
        touched?: boolean,
        error?: string
    };
    selectsEnd?: boolean;
    selectsStart?: boolean;
    startDate?: string;
    endDate?: string;
    disabled?: boolean;
}

export class TableCellRenderDatePicker extends React.PureComponent<Props> {
    get momentDate() {
        return moment(this.props.input.value, 'YYYY-MM-DD');
    }

    handleChange = (date: string) => {
        const momentDate = moment(date);
        if (momentDate.isValid()) {
            this.props.input.onChange(momentDate.format('YYYY-MM-DD'));
        } else {
            this.props.input.onChange(null);
        }
    };

    handleBlur = (event: any) => {
        const date =
            event.target.value &&
            moment(event.target.value, 'DD/MM/YYYY').format();
        this.props.input.onBlur(date);
    };

    render() {
        const {
            input,
            // meta: { error },
            selectsEnd,
            selectsStart,
            startDate,
            endDate,
            disabled
            // isSelected
        } = this.props;

        return (
            <div onClick={event => event.stopPropagation()}>
                <MediaQuery minWidth={767}>
                    {matches => (
                        <AsyncDatePicker
                            // popperContainer={DatePickerContainer}
                            dateFormat="dd/MM/yyyy"
                            selected={
                                input.value && this.momentDate.isValid()
                                    ? this.momentDate.toDate()
                                    : null
                            }
                            onChange={this.handleChange}
                            withPortal={!matches}
                            selectsEnd={selectsEnd}
                            selectsStart={selectsStart}
                            startDate={startDate && moment(startDate).toDate()}
                            endDate={endDate && moment(endDate).toDate()}
                            disabled={disabled}
                            customInput={
                                <Input
                                    transparent
                                    fluid
                                    style={{
                                        border: 'none',
                                        position: 'relative',
                                        left: -1
                                    }}
                                />
                            }
                        />
                    )}
                </MediaQuery>
            </div>
        );
    }
}

export default TableCellRenderDatePicker;
